
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { CustomField, PropertyList } from "./PropertyListWidget.js";
import { sortWith, map } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { unwrap, bind, map as map_1, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { tryParsePrice, priceToString } from "../Common.js";
import { sortAsc } from "../SharedComponents/NaturalOrder.js";

export function CustomPropertiesPropertyList(props) {
    const t = useTranslation()[0];
    return createElement(PropertyList, {
        Properties: map((customProperty) => {
            const matchValue = customProperty.Type;
            switch (matchValue) {
                case "enum": {
                    const Value_1 = defaultArg(customProperty.TextValue, "");
                    return {
                        Label: customProperty.Label,
                        TestId: concat("custom-property-enum-", ...customProperty.Label),
                        Value: Value_1,
                    };
                }
                case "multiEnum": {
                    const Value_2 = defaultArg(customProperty.TextValue, "");
                    return {
                        Label: customProperty.Label,
                        TestId: concat("custom-property-multi-enum-", ...customProperty.Label),
                        Value: Value_2,
                    };
                }
                case "bool": {
                    const Value_3 = defaultArg(map_1((value_3) => {
                        if (value_3) {
                            return t("general.yes");
                        }
                        else {
                            return t("general.no");
                        }
                    }, customProperty.BoolValue), "");
                    return {
                        Label: customProperty.Label,
                        TestId: concat("custom-property-bool-", ...customProperty.Label),
                        Value: Value_3,
                    };
                }
                case "date": {
                    const Value_4 = defaultArg(map_1((value_5) => toString(value_5, "dd.MM.yyyy"), customProperty.DateValue), "");
                    return {
                        Label: customProperty.Label,
                        TestId: concat("custom-property-date-", ...customProperty.Label),
                        Value: Value_4,
                    };
                }
                case "url": {
                    const Value_5 = defaultArg(customProperty.TextValue, "");
                    return {
                        CustomField: new CustomField(0, []),
                        Label: customProperty.Label,
                        TestId: concat("custom-property-url-", ...customProperty.Label),
                        Value: Value_5,
                    };
                }
                case "currency": {
                    const Value_6 = defaultArg(map_1((price) => priceToString(price, props.Currency), bind(tryParsePrice, customProperty.TextValue)), "");
                    return {
                        Label: customProperty.Label,
                        TestId: concat("custom-property-currency-", ...customProperty.Label),
                        Value: Value_6,
                    };
                }
                default: {
                    const Value = defaultArg(customProperty.TextValue, "");
                    return {
                        Label: customProperty.Label,
                        TestId: concat("custom-property-text-", ...customProperty.Label),
                        Value: Value,
                    };
                }
            }
        }, sortWith((globalPropertyA, globalPropertyB) => (sortAsc(globalPropertyA.Label, globalPropertyB.Label) | 0), props.CustomProperties)),
        Title: unwrap(props.Title),
    });
}

